<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 92.111 106.809"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <title
      v-if="iconName !== ''"
      :id="iconName"
      lang="en"
    >{{ iconName }} icon</title>
    <g :fill="iconColor" id="Group_3416" data-name="Group 3416" transform="translate(-835.424 -257.137)">
      <path id="Path_4339" data-name="Path 4339" d="M695.207,306.894c0-.94-.041-1.909-.124-2.957a2.908,2.908,0,0,0,.082-1.037A38.015,38.015,0,0,0,657.314,269h-.13l0,1.352L657.03,269h-.13a38.021,38.021,0,0,0-37.853,33.919,2.868,2.868,0,0,0,.085,1.018c-.085,1.061-.126,2.032-.126,2.957,0,.877.032,1.785.1,2.7a2.936,2.936,0,0,0-.087,1.018,38.043,38.043,0,0,0,22.451,30.9,1.234,1.234,0,0,1,.741,1.111v5.714a5.564,5.564,0,0,0-3.023,4.923v2.063a5.519,5.519,0,0,0,.68,2.653,5.522,5.522,0,0,0-.68,2.653v2.063a5.542,5.542,0,0,0,5.527,5.528h.005a7.851,7.851,0,0,0,7.824,7.59h9.129a7.851,7.851,0,0,0,7.824-7.59h0a5.54,5.54,0,0,0,5.526-5.53v-2.06a5.491,5.491,0,0,0-.68-2.654,5.5,5.5,0,0,0,.68-2.653v-2.065A5.566,5.566,0,0,0,672,348.336v-5.7a1.237,1.237,0,0,1,.745-1.122A38.045,38.045,0,0,0,695.2,310.6a2.874,2.874,0,0,0-.086-1.007C695.174,308.676,695.207,307.77,695.207,306.894Zm-34.687,64.518c-.019,0-.038-.005-.058-.005h-7.752a3.43,3.43,0,0,1-3.426-3.426v-1.114h15.644v1.114a3.429,3.429,0,0,1-3.426,3.426h-.922C660.559,371.406,660.54,371.412,660.519,371.412Zm8.8-7.594h-24.44a1.128,1.128,0,0,1-1.126-1.128v-2.063a1.127,1.127,0,0,1,1.126-1.128h24.44a1.128,1.128,0,0,1,1.128,1.128v2.063A1.129,1.129,0,0,1,669.324,363.818Zm-10.758-28.339a1.131,1.131,0,0,1,1.129,1.129h0v12.474h-5.181V336.607a1.13,1.13,0,0,1,1.128-1.129Zm-9.752-19.866H665.4v8.3l-5.788,7.233a5.657,5.657,0,0,0-.869-.072h-3.272a5.449,5.449,0,0,0-.868.073l-5.787-7.235Zm-5.058,39.71V353.26a1.129,1.129,0,0,1,1.128-1.128h24.44a1.128,1.128,0,0,1,1.128,1.128v2.062a1.128,1.128,0,0,1-1.128,1.128h-24.44A1.129,1.129,0,0,1,643.756,355.322Zm42.9-35.489a32.273,32.273,0,0,1-16.415,16.413,6.991,6.991,0,0,0-4.168,6.375v5.108l.136,1.352h-3.3V336.607a4.131,4.131,0,0,0-.418-1.809l7.137-8.921a1.521,1.521,0,0,0,.335-.955V314.26h.815a1.525,1.525,0,0,0,.069-3.049.59.59,0,0,0-.069,0h-.817a1.524,1.524,0,0,0-1.524-1.494c-.028,0-.057.007-.085.008s-.055-.008-.085-.008a1.523,1.523,0,0,0-1.522,1.494h-19.29a1.524,1.524,0,0,0-1.524-1.494c-.028,0-.057.007-.084.008s-.055-.008-.085-.008a1.524,1.524,0,0,0-1.524,1.494h-.817a1.525,1.525,0,1,0-.07,3.049h.886v10.665a1.527,1.527,0,0,0,.334.955l6.957,8.7c.013.193.027.4.043.612a4.131,4.131,0,0,0-.281,1.421v12.472h-3.166v-6.464a6.99,6.99,0,0,0-4.167-6.368,32.348,32.348,0,1,1,42.7-16.416Z" transform="translate(232.325 -11.863)"/>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
